import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

import * as fromCollaborators from '../../users';
import { ServiceFunction } from '../../users';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-services-functions-list',
  templateUrl: './service-functions-list.component.html',
  styleUrls: ['./service-functions-list.component.scss'],
  standalone: false,
})
export class ServiceFunctionsListComponent implements OnInit {
  @Input() functionQuery: string | null;
  @Input() isActiveShowAllFunctionsButton: boolean;
  @Input() functions: fromCollaborators.ServiceFunction[] | null;

  @Output() onChangeVisibilityAllFunctions = new EventEmitter<any>();
  @Output() onOpenServiceFunctionDialog = new EventEmitter<any>();
  @Output() onChangeStateServiceFunction = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}

  onChangeStateFunction(event, func: ServiceFunction) {
    event.target.checked = func.is_visible;

    this.onChangeStateServiceFunction.emit(func);
  }
}
